import http from '@/services/rest/rest.service';
import { IAdminAccountModel } from '@/entities/admins/admin-account-model.interface';
import { IAdminUpdateProfileModel } from '@/entities/admins/admin-update-profile-model.interface';
import { IOfficeEdit } from '@/entities/offices/office-edit.interface';
import { IAgentUpdateProfileModel } from '@/entities/agents/agent-update-profile-model.interface';

export default {
    adminDetails(): Promise<IAdminAccountModel> {
        return http.get('profile/admin');
    },
    updateAdmin(model: IAdminUpdateProfileModel): Promise<number> {
        return http.post('profile/admin', model);
    },
    companyDetails(): Promise<IOfficeEdit> {
        return http.get('profile/company');
    },
    updateCompany(model: IOfficeEdit): Promise<number> {
        return http.post('profile/company', model);
    },
    updateAgent(model: IAgentUpdateProfileModel): Promise<number> {
        return http.post('profile/agent', model);
    }
};
